(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-trust-icons"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const track = document.querySelector(".trust-icons-track");
  const items = document.querySelectorAll(".trust-icon-item");
  const prev = document.querySelector(".trust-prev");
  const next = document.querySelector(".trust-next");
  const pagination = document.querySelector(".trust-icons-pagination");

  if (!track || !items.length) return;

  let index = 0;

  function perView() {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  }

  function update() {
    const view = perView();
    const total = Math.ceil(items.length / view);
    const width = track.parentElement.offsetWidth;

    track.style.transform = `translateX(-${index * width}px)`;
    pagination.textContent = `${index + 1} / ${total}`;

    prev.disabled = index === 0;
    next.disabled = index === total - 1;
  }

  prev.addEventListener("click", () => {
    if (index > 0) {
      index--;
      update();
    }
  });

  next.addEventListener("click", () => {
    const total = Math.ceil(items.length / perView());
    if (index < total - 1) {
      index++;
      update();
    }
  });

  window.addEventListener("resize", () => {
    index = 0;
    update();
  });

  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('s1-sticky-buy')) {
  customElements.define('s1-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productRoot);
      this.button = this.querySelector('[data-sticky-button]');
      this.price = this.querySelector('[data-sticky-price]');
      if (!this.root || !this.button) return;
      this.controller = new AbortController();
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.frame = 0;
      this.above = false;
      this.native = null;
      this.nativePrice = null;
      const options = { signal: this.controller.signal };
      this.queue = () => {
        if (!this.mobile.matches && this.hidden) return;
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.button.addEventListener('click', () => this.activate(), options);
      this.mobile.addEventListener('change', this.queue, options);
      document.addEventListener('focusin', this.queue, options);
      document.addEventListener('focusout', this.queue, options);
      document.addEventListener('click', () => { if (!this.hidden) this.queue(); }, options);
      document.addEventListener('toggle', this.queue, { ...options, capture: true });
      this.root.addEventListener('change', this.queue, options);
      this.visibilityObserver = new IntersectionObserver(entries => {
        const entry = entries.find(item => item.target === this.native);
        if (!entry) return;
        const above = !entry.isIntersecting && entry.boundingClientRect.bottom < 0 && entry.boundingClientRect.height > 0 && entry.boundingClientRect.width > 0;
        if (this.above !== above) {
          this.above = above;
          this.queue();
        }
      // Extend below the page so an anchor jump from below to above the
      // viewport still crosses the observer boundary without scroll polling.
      }, { threshold: 0, rootMargin: '0px 0px 100000px 0px' });
      this.stateObserver = new MutationObserver(this.queue);
      this.observer = new MutationObserver(records => {
        const relevant = (this.native && !this.native.isConnected) || (this.nativePrice && !this.nativePrice.isConnected) || records.some(record => Array.from(record.addedNodes).some(node => node instanceof Element && (node.matches('[data-add-to-cart], [data-product-price]') || node.querySelector('[data-add-to-cart], [data-product-price]'))));
        if (relevant) {
          this.bindControls();
          this.queue();
        }
      });
      this.observer.observe(this.root, { subtree: true, childList: true });
      this.overlayObserver = new MutationObserver(this.queue);
      this.overlayObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.barSizeObserver = new ResizeObserver(entries => {
        if (this.hidden) return;
        const height = (entries[0].borderBoxSize?.[0]?.blockSize ?? this.offsetHeight) + 'px';
        if (this.barHeight !== height) {
          this.barHeight = height;
          document.documentElement.style.setProperty('--s1-sticky-buy-height', height);
        }
      });
      this.barSizeObserver.observe(this);
      this.bindControls();
      this.sync();
    }
    bindControls() {
      const native = this.root.querySelector('form [data-add-to-cart]');
      const price = this.root.querySelector('[data-product-price]');
      if (native === this.native && price === this.nativePrice) return;
      if (native !== this.native) {
        this.visibilityObserver.disconnect();
        this.above = false;
        this.native = native;
        if (native) this.visibilityObserver.observe(native);
      }
      this.nativePrice = price;
      this.stateObserver.disconnect();
      if (native) this.stateObserver.observe(native, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'aria-busy'] });
      if (price) this.stateObserver.observe(price, { subtree: true, childList: true, characterData: true });
    }
    configurationTarget() {
      return this.root.querySelector('kit-variant-picker, .variant-input-wrap, .gpo-product-variants input, .gpo-product-variants select, .gpo-product-variants textarea, [name^="properties["]:not([type="hidden"]), [name="selling_plan"]');
    }
    needsOptions() {
      return this.dataset.needsOptions === 'true' || Boolean(this.root.querySelector('.gpo-product-variants input, .gpo-product-variants select, .gpo-product-variants textarea, [name^="properties["]:not([type="hidden"]), [name="selling_plan"]'));
    }
    setVisible(visible) {
      if (this.hidden === visible) this.hidden = !visible;
      if (document.documentElement.classList.contains('s1-sticky-buy-visible') !== visible) document.documentElement.classList.toggle('s1-sticky-buy-visible', visible);
    }
    sync() {
      if (!this.mobile.matches) { this.setVisible(false); return; }
      const native = this.native;
      if (!native) { this.setVisible(false); return; }
      const price = this.nativePrice;
      const label = native.querySelector('[data-add-to-cart-text]');
      const busy = native.classList.contains('btn--loading') || native.getAttribute('aria-busy') === 'true';
      const configurable = this.needsOptions();
      const buttonText = configurable ? this.dataset.optionsLabel : (label ? label.textContent.trim() : native.textContent.trim());
      const disabled = busy || (!configurable && native.disabled);
      const priceText = price ? price.textContent.trim() : null;
      const editing = document.activeElement && document.activeElement.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="button"]):not([type="submit"]), textarea, [contenteditable="true"]');
      const chat = document.querySelector('shopify-chat');
      if (chat && this.chat !== chat) {
        this.chat = chat;
        this.overlayObserver.observe(chat, { attributes: true, attributeFilter: ['open'] });
      }
      const chatOpen = chat?.hasAttribute('open');
      const blocked = Boolean(chatOpen) || document.documentElement.matches('.js-drawer-open, .lock-scroll') || Boolean(document.querySelector('.modal--is-active, dialog[open]'));
      if (this.button.textContent !== buttonText) this.button.textContent = buttonText;
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
      if (this.button.getAttribute('aria-busy') !== String(busy)) this.button.setAttribute('aria-busy', String(busy));
      if (this.price && priceText !== null && this.price.textContent !== priceText) this.price.textContent = priceText;
      this.setVisible(this.above && !blocked && !editing);
    }
    activate() {
      const native = this.root.querySelector('form [data-add-to-cart]');
      if (!native) return;
      if (this.needsOptions()) {
        const target = this.configurationTarget() || native;
        const region = target.closest('.product-block, .gpo-product-variants') || target;
        const header = document.getElementById('SiteHeader');
        const offset = header ? Math.min(header.offsetHeight, 200) + 24 : 100;
        const top = region.getBoundingClientRect().top + window.scrollY - offset;
        const focus = target.matches('input, select, textarea, button') ? target : target.querySelector('input, select, button');
        if (focus) focus.focus({ preventScroll: true });
        window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      } else if (!native.disabled && !native.classList.contains('btn--loading')) {
        native.click();
      }
      this.queue();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.stateObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.overlayObserver?.disconnect();
      this.barSizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.setVisible(false);
    }
  });
}

if (!customElements.get('s1-bed-guide-pilot')) {
  customElements.define('s1-bed-guide-pilot', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productRoot);
      if (!this.root) return;
      this.mount = () => {
        this.root.querySelectorAll('.gpo-element.gpo-form__group').forEach(group => {
          let kind;
          if (group.querySelector('input[data-field-name="jäykkyys"], input[data-field-name="Jäykkyys oikea puoli"]')) kind = 'firmness';
          if (group.querySelector('input[data-field-name="Petauspatja"]')) kind = 'topper';
          if (!kind || group.querySelector('.s1-bed-guide')) return;
          const template = this.querySelector('[data-guide-template="' + kind + '"]');
          if (!template) return;
          const guide = template.content.firstElementChild.cloneNode(true);
          guide.dataset.s1BedGuide = kind;
          group.appendChild(guide);
        });
      };
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.mount(); });
      });
      this.observer.observe(this.root, { childList: true, subtree: true });
      this.mount();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.root?.querySelectorAll('[data-s1-bed-guide]').forEach(guide => guide.remove());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
